import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from '@angular/common/http';
import { BBResponseContainer } from "../carrier/response-container";
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { MaterialType } from "../carrier/carrier-enum";
import { ReactionPlacementRequest } from "./reaction-placement-request";
import { timeout, tap } from 'rxjs/operators';
import { RedoCancelReactionSetRequest } from './redoorcancel-reactionset-request';
import { ReactionPlacementRetainPositionRequest } from './reaction-placement-retain-position-request';


/**
 * @author Naveen
 * @description Supreme run reactions set service
 */
@Injectable()
export class ReactionSetService {

    constructor(private http: HttpClient) { }

    /**
         * @description Find Carrier by barcode.
         * @param barcode
        */
    placeReactionSetsOnPlate(rpRequest: ReactionPlacementRequest): Observable<BBResponseContainer> {
        let url = environment.BB_SEQUENCING_SERVICE_URL + 'reactionPlate/placeReactions';
        return this.http.post<BBResponseContainer>(url, rpRequest).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
            error.url = url;
        }));
    }

    /**
     * @description Place reaction sets to retain positions
     * @param rpRequest
     */
    placeReactionSetsToRetainPositions(rpRequest: Array<ReactionPlacementRetainPositionRequest>): Observable<BBResponseContainer> {
        let url = environment.BB_SEQUENCING_SERVICE_URL + 'reactionPlate/placeReactionsToRetainPositions';
        return this.http.post<BBResponseContainer>(url, rpRequest).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
            error.url = url;
        }));
    }

    /**
    * @function
    * @param MaterialType
    * @description Make service call to reaction set endpoint
   */
    fetchReactionSets(materialType: MaterialType, labId: string): Observable<BBResponseContainer> {
        let url = environment.BB_SEQUENCING_SERVICE_URL + 'reactionset' + "/" + labId;
        let requestParam = new HttpParams().set('materialType', materialType);
        const options = materialType ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
            error.url = url;
        }));
    }

    fetchReactionSetsWithFilter(primerName: string, sampleContainer: string[], selectedPriority: string[], selectedSampleUsageType: string[]
        , selectedReactionOptionProtocol: string[], selectedPrimerType: string[], labId: string): Observable<BBResponseContainer> {
        const url = environment.BB_SEQUENCING_SERVICE_URL + 'reactionset' + '/' + labId + '/filter';
        const params = new HttpParams()
            .set('sampleContainer', sampleContainer.toString())
            .set('priority', selectedPriority.toString())
            .set('sampleUsageType', selectedSampleUsageType.toString())
            .set('reactionOptionProtocol', selectedReactionOptionProtocol.toString())
            .set('primerType', selectedPrimerType.toString())
            .set('primerName', primerName);
        return this.http.get<BBResponseContainer>(url, { params }).pipe(timeout(environment.defaultTimeout),
            tap(event => { }, error => {
                error.url = url;
            }));
    }
    fetchReactionSetsToManage(orderID: string): Observable<BBResponseContainer> {
        let url = environment.BB_SEQUENCING_SERVICE_URL + 'reactionset/order' + "/" + orderID;
        return this.http.get<BBResponseContainer>(url).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
            error.url = url;
        }));
    }

    updateReactionSetsWithRedoOrCancel(redoCancelReactionSetRequest: RedoCancelReactionSetRequest) {
        let url = environment.BB_SEQUENCING_SERVICE_URL + 'reactionset/redoOrCancel';
        return this.http.put<BBResponseContainer>(url, redoCancelReactionSetRequest).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
            error.url = url;
        }));
    }

    removeReactionSetsFromPlate(rpRequest: ReactionPlacementRequest): Observable<BBResponseContainer> {
        let url = environment.BB_SEQUENCING_SERVICE_URL + 'reactionPlate/removeReactions';
        return this.http.put<BBResponseContainer>(url, rpRequest).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
            error.url = url;
        }));
    }
}
